import React from "react";
import { Alert } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

const GenericImplantRushAlert: React.FC = () => (
  <Alert
    color="red"
    variant="light"
    icon={<IconAlertTriangle size={20} />}
    style={{ marginBottom: "1rem" }}
  >
    En choisissant des délais de fabrication raccourcis, vous acceptez de
    remplacer le pilier original fabriquant par un pilier personnalisé.
  </Alert>
);

export default GenericImplantRushAlert;
